// extracted by mini-css-extract-plugin
export default {"shimmerWrapper":"Shimmer_shimmerWrapper__N9ZHH","shimmer":"Shimmer_shimmer__+ui+Z","shimmerText":"Shimmer_shimmerText__W+QQi"};